const ConditionalWrapper = ({ condition, wrapper, altWrapper, children }) =>
  condition ? wrapper(children) : altWrapper(children);

export default ConditionalWrapper;